import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.css";
import { Modal } from "react-bootstrap";
import axios from 'axios';

function Rightbar() {
    const [task, setTask] = useState(false);

    const handleTaskClose = () => setTask(false);
    const handleTaskShow = () => setTask(true);
    
     const addTask = async (task) => {
    axios
        .post("https://empmgtapp.herokuapp.com/api/task/createTask/612940ccc9e8cc0016b4aa4f", {
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(task),
        })
        .then((response) => {
          console.log(response);
        })
        .catch((error) => {
          console.log(error);
        });
      alert("Task Created Successfully");
    };

    return (
        <div className='right-bar'>

            <div>
                <div className='right-btn' style={{margin:'50% 25% 50% 30%'}}>
                  <button style ={{marginBottom:'20px'}}>Send Email</button><br/>
                <button>Suggestions</button>
                </div>
                <div className='right-btn' style={{margin:'50% 25% 50% 30%'}}>
                  <button onClick={handleTaskShow}>Create Task</button>
                </div>
                
                <Modal show={task} onHide={handleTaskClose}>
          <Modal.Header closeButton>
            <Modal.Title className="vw-100" style={{ fontWeight: 700 }}>
              Create Task
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="vh-80" style={{marginBottom:'80px'}}>
            <form>
              <label
                for="task tittle"
                style={{ fontWeight: "700", marginTop: "10px", display:'flex', marginLeft:'20px', marginBottom:'-20px'}}
              >
                Task Title
              </label>
              <br />
 
              <input type="text" style={{width:'432px', height:'50px', borderRadius:'10px', border:'2px solid #3D50C7', margin:'10px 20px'}} required />
              <br />
              <label
                for="task description"
                style={{ fontWeight: "700", marginTop: "20px", display:'flex', marginLeft:'20px', marginBottom:'-20px'}}
              >
                Task Description
              </label>
              <br />
              <input type="text" style={{width:'432px', height:'116px', borderRadius:'10px', border:'2px solid #3D50C7', margin:'10px 20px'}} required/>
              <br />
              <h5 style={{ textAlign: "right", marginTop: "30px" }}>
                <span><a href="Upload"><i class="fas fa-paperclip"></i></a>
                </span>
                <input type='file'  style={{display:'none'}}/>
                Add Attachment
              </h5>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "çenter",
                  marginTop: "30px",
                }}
              >
                <div>
                  <p for="taskdate" style={{ fontWeight: "700" }}>
                    Task Due Date
                  </p>
                </div>
                <div>
                  <input
                    type="date"
                    placeholder="Select Date"
                    style={{width:'auto', height:'auto' }}
                    required
                  />
                </div>
              </div>
              <div>
                <span
                  style={{
                    fontWeight: "700",
                    fontSize: "16px",
                    display: "flex",
                    marginTop: "30px", color:'black'
                  }}
                >
                  Assign To
                  _________________________________________________________ Add
                </span>
              </div>
            </form>
            <div>
              <button
                onClick={addTask}
                className="modal-btn"
                style={{width:'177px', height:'54px', border:'2px solid #3D50C7', borderRadius:'10px', fontWeight:'700', margin:'100px 0 50px 150px'}}
              >
                Create Task
              </button>
              <button
                onClick={handleTaskClose}
                className="modal-btn--2"
                style={{width:'177px', height:'54px', border:'2px solid #3D50C7', borderRadius:'10px', fontWeight:'700', margin:'100px 0 50px 150px'}}
              >
                Cancel
              </button>
            </div>

          </Modal.Body>
        </Modal>
      </div>
      <div>

      </div>
                
        </div>
    )
}

export default Rightbar;
